import request from '@/utils/request'

export const NotificationReadStatus = {
  Unread: 0,
  Read: 1
} as const

export interface NotificationItem {
  id: number
  type?: string
  title: string
  content: string
  storeCode?: string
  storeName?: string
  readStatus: number
  readTime?: number
  createTime: number
  bizId?: number
  bizType?: string
  productId?: string
  productTitle?: string
  remark?: string
  hitCount?: number
  lastPreOrderTime?: number
  paymentProviders?: string[]
  providerAccounts?: string[]
}

export interface NotificationPageParams {
  pageNum: number
  size: number
  storeCode?: string
  type?: string
  readStatus?: number
}

export interface NotificationPageResult {
  records: NotificationItem[]
  total: number
}

export interface ReadNotificationParam {
  id?: number
  ids?: number[]
  readAll?: boolean
  type?: string
}

export const isNotificationUnread = (item: Pick<NotificationItem, 'readStatus'>) =>
  item.readStatus === NotificationReadStatus.Unread

const BASE = '/api/goods/notification'

export function getNotificationPage(data: NotificationPageParams) {
  return request<NotificationPageResult>({
    url: `${BASE}/page`,
    method: 'post',
    data
  })
}

export function markNotificationRead(data: ReadNotificationParam) {
  return request<boolean>({
    url: `${BASE}/read`,
    method: 'post',
    data
  })
}
